const imgUrl = {
    //'logo' : require('./covidkayalogo.png'),
    'dohlogo' : require('./dohlogo.png'),
    //'coughing' : require('./coughing.jpg'),
    //'loginPageImage' : require('./loginPageImage.jpg'),
    //'durelogowhite' : require('./durelogowhite.png'),
    'addUser' : require('./home/lightgreen/add-user.svg'),
    'search' : require('./home/lightgreen/search.svg'),
    'alert' : require('./home/lightgreen/alert.svg'),
    'records' : require('./home/lightgreen/records.svg'),
    'referral' : require('./home/lightgreen/referral.svg'),
    'file_download' : require('./home/lightgreen/file-download.svg'),
    'file_upload' : require('./home/lightgreen/file-upload.svg'),
    'chatbot' : require('./newloginpageicons/chatbot.png'),
    'guide' : require('./newloginpageicons/guide.png'),
    'pdf' : require('./newloginpageicons/pdf.png'),
    'video_tutorial' : require('./newloginpageicons/video-tutorial.png'),
    'patientHome' : require('./Patient.png'),
    'prov-home' : require('./Provider.png'),
    'back':require('../images/back.png'),
    'clientImg':require('../images/customer.png'),
    'transferImg':require('../images/transfer.png'),
    'referalImg':require('../images/referral.png'),
    'alertImg':require('../images/bell.png'),
    'treatment':require('../images/calendar.png'),
    'history':require('../images/medical-record.png'),
    'user':require('../images/user.png'),
    'chatbot':require('../images/chatbot.png'),
    //'icon':require('../images/icon.svg'),
    'newprofile':require('../images/user.png'),
    'linelist':require('../images/book.png'),
    'who-logo': require('../images/who-logo.png'),
    'client-logo': require('../images/Client.png'),
    'backlogo':require('../images/left-chevron.png'),
    'ethiopiaflag': require('../images/eth-flag.png'),
    'elearning':require('./../images/elearning.png'),
    'guide':require('../images/guidelines.png'),
    'certify':require('../images/certification.png'),
    'no_plan':require('../images/no_plan.png'),

}

export default imgUrl;